import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { NotificationsPage } from "../components/notifications/notifications-page.tsx";

interface Search {
  readonly typ?: string;
  readonly olasta?: boolean;
}

/**
 * The filter lives in the URL rather than in component state.
 *
 * "Show me the cancellations" is a view somebody lands on, reloads, and sends to the owner
 * who is not in the building. Held in `useState` it would survive none of those.
 */
export const Route = createFileRoute("/aviseringar")({
  component: Screen,
  validateSearch: (search: Record<string, unknown>): Search => ({
    ...(typeof search.typ === "string" ? { typ: search.typ } : {}),
    ...(search.olasta === true || search.olasta === "true" ? { olasta: true } : {}),
  }),
});

function Screen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <NotificationsPage
      filter={{ kind: search.typ ?? null, unreadOnly: search.olasta ?? false }}
      onFilterChange={(next) =>
        void navigate({
          search: {
            ...(next.kind === null ? {} : { typ: next.kind }),
            ...(next.unreadOnly ? { olasta: true } : {}),
          },
          replace: true,
        })
      }
    />
  );
}
